module.exports = __webpack_public_path__ + "img/therapy.c8c70f0a.webp";